export default __webpack_public_path__ + "static/team-d9c8837ac05f1f7ef491c4ed9e109931.jpg";